import { availableComponents, renderingTools } from '@as-react/as-react';
import type { AemConfiguration } from '@as-react/common-types';
import { Hydrater } from '@as-react/hydrater';
import { Logger } from '@as-react/logger';

import { bootstrap } from './client/bootstrap';
import { activateMediatorSubscribers } from './client/mediator/mediatorSubscriber';
import { initI18nClient } from './modules/i18n/i18n-client';
import { TESTING_MODE } from './utils/runtime';

import './utils/polyfills';

declare const SITE: { Config: AemConfiguration };

const locale = SITE.Config.locale;
const translationLang = SITE.Config.translationLang;

(async () => {
  await Logger.init({
    release: process.env.REACT_VERSION!,
  });

  const i18n = await initI18nClient({
    translationLang,
    locale,
  });

  try {
    activateMediatorSubscribers();
  } catch {}

  if (process.env.TESTING_MODE === TESTING_MODE.MOCKED) {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  } else {
    bootstrap();
  }

  await Hydrater({
    availableComponents,
    root: document,
    renderingTools,
    locale,
    translationLang,
    i18n,
  });
})();
